import { addMonths } from 'date-fns';
import { UTCDate } from '@date-fns/utc';

/** Stripe-matching first-charge proration for pre-creation surfaces (no live sub to
 *  preview). Used only for add-sport: the partial first period runs to the cohort's
 *  inherited billing anchor; matches Stripe's proration to ~1¢. Returns full monthly
 *  when the cycle fits before periodEnd, 0 for a degenerate past period. */
export function prorateFirstCharge(
  monthlyCents: number,
  periodStart: Date,
  periodEnd: Date,
): number {
  // UTCDate keeps month arithmetic in UTC (Stripe prorates in UTC), TZ-independent.
  const cycleEnd = addMonths(new UTCDate(periodStart), 1);
  if (periodEnd >= cycleEnd) return monthlyCents;
  if (periodEnd <= periodStart) return 0;
  const periodMs = periodEnd.getTime() - periodStart.getTime();
  const cycleMs = cycleEnd.getTime() - periodStart.getTime();
  return Math.round((monthlyCents * periodMs) / cycleMs);
}
